import React, { Component } from 'react';
import { AuthenticatedUser, ImpersonatingUser } from '~/Api/Authentication';
import Button from '~/UI/Button';

import styles from './styles.less';

interface Props {
	user: AuthenticatedUser | null;
	impersonatedBy: ImpersonatingUser | null;
	onSwitchBack: () => void;
}

export default class Panel extends Component<Props> {
	static defaultProps = {
		impersonatedBy: null,
	};

	render() {
		const { user, impersonatedBy, onSwitchBack } = this.props;

		return user !== null && impersonatedBy !== null ? (
			<div className={styles.panel}>
				<div className={styles.content}>
					<p className={styles.text}>
						Impersonating <strong>{this.renderName(user)}</strong>
						<span className={styles.separator} />
						Switch back to{' '}
						<Button styles={styles} onClick={onSwitchBack}>
							{this.renderName(impersonatedBy)}
						</Button>
					</p>
				</div>
			</div>
		) : null;
	}

	renderName(user: { name: string | null; email: string }) {
		return user.name !== null ? user.name : user.email;
	}
}
